<template>
  <div v-show="isEnabled" class="tts">
    <div ref="embedMe"></div>
    <div class="tts__player">
      <div v-if="isOpened && title" class="tts__player-title">
        <UTooltip class="align-middle" :text="$t('articles.tts_tooltip')">
          <DefaultIconsTooltip class="fill-white/35 w-5"/>
        </UTooltip>
        <span class="tts__player-title-text" :title="title">
          {{title}}
        </span>
      </div
      >
      <div id="embed-me-here" class="tts__player-inner"></div>

      <NuxtLink v-if="isOpened" class="tts__player-close-btn" @click="closePlayer">
        <!-- todo - create icon component -->
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </NuxtLink>
    </div>
  </div>
</template>

<script setup lang="ts">
import {onMounted, useTemplateRef} from "vue"
import type TtsPlayerEventPayload from "~/libs/interfaces/TtsPlayerEventPayload"
import {useTts} from "~/composables/useTts"
import {type TtsEvent, type TtsObject} from "~/libs/interfaces/TtsPlayerMode";

declare global {
  interface Window {
    tts?: any
  }
}

const id = ref<string|null|undefined>(null)
const title = ref<string|null|undefined>(null)
const isOpened = ref(false)

const isEnabled = computed(() => {
  return useTts().isEnabled()
})

const embedMe = useTemplateRef('embedMe')
const ttsReady: Ref<boolean> = ref(false)
const initialProps: Ref<TtsPlayerEventPayload | null> = ref(null)

const openPlayer = (id?: string) => {
  if (isOpened.value !== true) {
    isOpened.value = true
    getTts()?.open()
  }
  getTts()?.play(id)
}

const closePlayer = () => {
  isOpened.value = false
  getTts()?.close()
}

const hasTts = (): boolean => {
  if ((!import.meta.client && window)) {
    return false
  }
  return !!window?.tts
}

const getTts = (): TtsObject | undefined => {
  if ((!import.meta.client && window)) {
    return undefined
  }
  return window.tts
}

const initTts = () => {
  if (!hasTts()) {
    return
  }
  if (!initialProps.value) {
    return
  }
  const tts = getTts()
  if (initialProps.value.id && tts) {
    tts.properties.value.id = initialProps.value.id
  }
}

onMounted(() => {
  if (import.meta.client && isEnabled && window) {
    // @ts-ignore
      window.addEventListener("tts:initialized", (e: TtsEvent) => {
        ttsReady.value = true
        initTts()
      })
      if (embedMe.value) {
        var embed = document.createElement("script") as HTMLScriptElement;
        embed.setAttribute("tts-target-id", "embed-me-here")
        embed.setAttribute("src", useTts().getEmbedUrl());
        embed.setAttribute("async", "");
        // @ts-ignore
        embedMe?.value?.append(embed)
      }
      useListen('tts-player:init', (payload: TtsPlayerEventPayload) => {
        if (hasTts() && getTts()?.getProperty("id")) {
          return
        }
        initialProps.value = payload
        if (!hasTts()) {
          return
        }
        initTts()
      })
  }

  // open player handle
  // stories fullscreen event handle
  useListen('tts-player:open', (payload: TtsPlayerEventPayload) => {
    if (!payload.id) {
      return
    }

    id.value = payload.id
    title.value = payload.title
    openPlayer(id.value)
  })
})
</script>

